'use client';

import { createWithEqualityFn } from 'zustand/traditional';
import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { applyDevtools } from '../storeUtils';
import { config } from '@/config';
import { ConfigState, initialConfigState } from '@/store/configStore/configState';

export interface ConfigStoreState extends ConfigState {
    updateConfig: (data: Partial<ConfigState>) => void;
}

export const useConfigStore = createWithEqualityFn<ConfigStoreState>()(
    persist(
        applyDevtools(
            (set) => ({
                ...initialConfigState,
                updateConfig: (data: Partial<ConfigState>) => {
                    set(
                        (state) => ({ ...state, ...data }),
                        false,
                        'Update config store with data provided',
                    );
                },
            }),
            { name: `MPW ${config.theme} Config Store` },
        ),
        {
            name: `mpw-${config.theme}-config-storage`,
            partialize: (state) => ({
                website_session_timeout: state.website_session_timeout,
                website_session_remember_me_timeout: state.website_session_remember_me_timeout,
                website_sensitive_area_timeout: state.website_sensitive_area_timeout,
                website_device_cookie_timeout: state.website_device_cookie_timeout,
                website_login_redirect_domain_whitelist:
                    state.website_login_redirect_domain_whitelist,
                website_2fa_methods: state.website_2fa_methods,
                website_2fa_email_resend_code_timeout: state.website_2fa_email_resend_code_timeout,
                website_google_recaptcha_v2_site_key: state.website_google_recaptcha_v2_site_key,
                website_sms_resend_code_timeout: state.website_sms_resend_code_timeout,
                website_faq_translate_tag_id: state.website_faq_translate_tag_id,
                website_google_tag_id: state.website_google_tag_id,
                usa_taxable_honoraria: state.usa_taxable_honoraria,
                short_cookie_name: state.short_cookie_name,
                website_registration_disabled_profession_ids:
                    state.website_registration_disabled_profession_ids,
                registration_relevantid_survey_id: state.registration_relevantid_survey_id,
            }),
        },
    ),
    shallow,
);
